(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gua-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('header').closest('.shopify-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const listenToCloseAllActiveMenus = () => {
    const closeAllActiveMenus = () => {
      const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
      const menuItem = event.target.closest('.v2-header__nav-menu-item');
      if (menuItem || submenuItem) return;
      const activeMenus = document.querySelectorAll('.v2-header--is-active');
      for (const activeMenu of activeMenus) {
        activeMenu.classList.remove('v2-header--is-active');
      }
      document.body.removeEventListener('click', closeAllActiveMenus);
    }
    document.body.addEventListener('click', closeAllActiveMenus);
  }

  document.body.addEventListener('click', function (event) {
    const header = event.target.closest('.v2-header');
    if (!header) return;

    const isUsingClick = header.classList.contains('v2-header--use-click');
    if (!isUsingClick) return;

    // If it doesn't have a nested menu, return
    if (!event.target.closest('li').querySelector('ul')) return;

    const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
    const menuItem = event.target.closest('.v2-header__nav-menu-item');
    if (!menuItem && !submenuItem) return;
    listenToCloseAllActiveMenus();

    if (submenuItem) {
      const activeSubmenus = header.querySelectorAll('.v2-header__nav-menu-submenu-item.v2-header--is-active');
      for (const activeSubmenu of activeSubmenus) {
        if (activeSubmenu !== submenuItem) {
          activeSubmenu.classList.remove('v2-header--is-active');
        }
      }
      submenuItem.classList.toggle('v2-header--is-active');
      event.preventDefault();
      return;
    }

    const activeMenus = header.querySelectorAll('.v2-header--is-active');
    for (const activeMenu of activeMenus) {
      if (activeMenu !== menuItem) {
        activeMenu.classList.remove('v2-header--is-active');
      }
    }
    menuItem.classList.toggle('v2-header--is-active');
    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tech-specs-section-mlv"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const tables = document.querySelectorAll('.itg_table_wrpr table');

    tables.forEach((table) => {
        const headers = Array.from(table.querySelectorAll('th'));
        const rows = table.querySelectorAll('tr');

        rows.forEach((row) => {
            const cells = row.querySelectorAll('td');
            cells.forEach((cell, index) => {
                if (headers[index]) {
                    const label = headers[index].innerText;
                    cell.setAttribute('data-label', label);
                }
            });
        });
    });

    // Loader element
    const loader = document.createElement('div');
    loader.id = 'loader';
    loader.style.display = 'none';
    loader.style.position = 'fixed';
    loader.style.top = '50%';
    loader.style.left = '50%';
    loader.style.transform = 'translate(-50%, -50%)';
    loader.style.padding = '20px';
    loader.style.backgroundColor = '#fff';
    loader.style.border = '1px solid #ccc';
    loader.style.zIndex = '1000';
    loader.innerText = 'Loading...';

    document.body.appendChild(loader);
 
    // Event listener for SKU links
    const skuLinks = document.querySelectorAll('.sku-link');

    skuLinks.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const sku = link.getAttribute('data-sku');
            const productHandle = link.getAttribute('data-product-url');

            // Reset loader text and show loader
            loader.innerText = 'Loading...';
            loader.style.display = 'block';
            skuLinks.forEach(link => link.style.pointerEvents = 'none');

            // Check if product handle is provided via the section setting
            if (productHandle) {
                window.location.href = `/products/${productHandle}`;
            } else {
                fetchProductData(sku);
            }
        });
    });

    function fetchProductData(sku, page = 1) {
        fetch(`/products.json?limit=250&page=${page}`)
            .then(response => response.json())
            .then(data => {
                let matched = false;

                data.products.forEach(product => {
                    product.variants.forEach(variant => {
                        if (variant.sku === sku) {
                            window.location.href = `/products/${product.handle}?variant=${variant.id}`;
                            matched = true;
                        }
                    });
                });

                if (!matched && data.products.length === 250) {
                    fetchProductData(sku, page + 1);
                } else if (!matched) {
                    loader.innerText = "Part Number wasn't found";
                    setTimeout(() => {
                        loader.style.display = 'none';
                        skuLinks.forEach(link => link.style.pointerEvents = 'auto');
                    }, 3000);
                }
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
                loader.innerText = "An error occurred. Please try again.";
                setTimeout(() => {
                    loader.style.display = 'none';
                    skuLinks.forEach(link => link.style.pointerEvents = 'auto');
                }, 3000);
            });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('header').closest('.shopify-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const listenToCloseAllActiveMenus = () => {
    const closeAllActiveMenus = () => {
      const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
      const menuItem = event.target.closest('.v2-header__nav-menu-item');
      if (menuItem || submenuItem) return;
      const activeMenus = document.querySelectorAll('.v2-header--is-active');
      for (const activeMenu of activeMenus) {
        activeMenu.classList.remove('v2-header--is-active');
      }
      document.body.removeEventListener('click', closeAllActiveMenus);
    }
    document.body.addEventListener('click', closeAllActiveMenus);
  }

  document.body.addEventListener('click', function (event) {
    const header = event.target.closest('.v2-header');
    if (!header) return;

    const isUsingClick = header.classList.contains('v2-header--use-click');
    if (!isUsingClick) return;

    // If it doesn't have a nested menu, return
    if (!event.target.closest('li').querySelector('ul')) return;

    const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
    const menuItem = event.target.closest('.v2-header__nav-menu-item');
    if (!menuItem && !submenuItem) return;
    listenToCloseAllActiveMenus();

    if (submenuItem) {
      const activeSubmenus = header.querySelectorAll('.v2-header__nav-menu-submenu-item.v2-header--is-active');
      for (const activeSubmenu of activeSubmenus) {
        if (activeSubmenu !== submenuItem) {
          activeSubmenu.classList.remove('v2-header--is-active');
        }
      }
      submenuItem.classList.toggle('v2-header--is-active');
      event.preventDefault();
      return;
    }

    const activeMenus = header.querySelectorAll('.v2-header--is-active');
    for (const activeMenu of activeMenus) {
      if (activeMenu !== menuItem) {
        activeMenu.classList.remove('v2-header--is-active');
      }
    }
    menuItem.classList.toggle('v2-header--is-active');
    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ywm-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.querySelector('header').closest('.shopify-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

    const listenToCloseAllActiveMenus = () => {
      const closeAllActiveMenus = (event) => {
      const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
      const menuItem = event.target.closest('.v2-header__nav-menu-item');
      if (menuItem || submenuItem) return;
      const activeMenus = document.querySelectorAll('.v2-header--is-active');
      for (const activeMenu of activeMenus) {
        activeMenu.classList.remove('v2-header--is-active');
      }
      document.body.removeEventListener('click', closeAllActiveMenus);
    }
    document.body.addEventListener('click', closeAllActiveMenus);
  }

  document.body.addEventListener('click', function (event) {
    const header = event.target.closest('.v2-header');
    if (!header) return;

    const isUsingClick = header.classList.contains('v2-header--use-click');
    if (!isUsingClick) return;
 

// Optional chaining prevents a TypeError if closest('li') returns null
if (!event.target.closest('li')?.querySelector('ul')) return;

    const submenuItem = event.target.closest('.v2-header__nav-menu-submenu-item')
    const menuItem = event.target.closest('.v2-header__nav-menu-item');
    if (!menuItem && !submenuItem) return;
    listenToCloseAllActiveMenus();

    if (submenuItem) {
      const activeSubmenus = header.querySelectorAll('.v2-header__nav-menu-submenu-item.v2-header--is-active');
      for (const activeSubmenu of activeSubmenus) {
        if (activeSubmenu !== submenuItem) {
          activeSubmenu.classList.remove('v2-header--is-active');
        }
      }
      submenuItem.classList.toggle('v2-header--is-active');
      event.preventDefault();
      return;
    }

    const activeMenus = header.querySelectorAll('.v2-header--is-active');
    for (const activeMenu of activeMenus) {
      if (activeMenu !== menuItem) {
        activeMenu.classList.remove('v2-header--is-active');
      }
    }
    menuItem.classList.toggle('v2-header--is-active');
    event.preventDefault();
  });

  } catch(e) { console.error(e); }
})();
})();
